import { OldUploadNotifiers } from '~/uploads/types';
import Uploader from './Uploader';

export async function monitorUploadProgress({
  updateUploadProgress,
  uploaderInstance,
  id,
}: {
  id: string;
  updateUploadProgress: OldUploadNotifiers['updateFileUploadProgress'];
  uploaderInstance: Uploader;
}) {
  if (!updateUploadProgress) return;

  const progressIterator = uploaderInstance.getProgressIterator();
  let item;

  // eslint-disable-next-line no-cond-assign
  while (!(item = progressIterator.next()).done) {
    // eslint-disable-line no-cond-assign
    const promisedProgress = item.value;

    // eslint-disable-next-line no-await-in-loop, no-loop-func
    await promisedProgress.then((progress) =>
      updateUploadProgress({
        id,
        uploaderInstance,
        progress,
        complete: false,
      })
    );
  }
  updateUploadProgress({
    id,
    uploaderInstance,
    complete: true,
    progress: 100,
  });
}
